import { DieselType } from '../../../core/types/transport/enums/dieselType';
import { SelectItem } from '../../../shared/types/util/selectItem';

export const dieselTypeItems: SelectItem<DieselType>[] = [
  { id: 'Blank', label: 'Blank' },
  { id: 'Colored', label: 'Farget' },
  { id: 'HVO', label: 'HVO' },
];
